import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { EventLogsProvider } from './context/EventLogsProvider'
import { EventLogsMain } from './components/EventLogsMain'

export const EventLogs = () => {
  return (
    <NuqsAdapter>
      <EventLogsProvider>
        <EventLogsMain />
      </EventLogsProvider>
    </NuqsAdapter>
  )
}
